module.exports = __webpack_public_path__ + "img/deletesign.a883420e.svg";